import React, { lazy, useCallback, useEffect, useMemo } from 'react'
import { Grid, makeStyles, Typography, FormLabel, FormControlLabel, Radio, FormHelperText } from '@material-ui/core'
import TextBox from '../../../../../shared/elements/FormItem/TextBox'
import Select from '../../../../../shared/elements/FormItem/Select'
import {preferredlanguageList, stateList, getStateFromZip } from '../../../../../containers/AppointmentBooking/constant'
import CheckboxOption from '../../../../ClinicalNotes/reusable/CheckboxOptions'
import IntakeModalForm from '../IntakeForm/IntakeModalForm'
import MomentUtils from '@date-io/moment'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import moment from 'moment'
import Autocomplete from '@mui/material/Autocomplete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { getAdditionalDemo } from '../../../../../services/Appointments/appointments'
import _ from "lodash";
import { StateTimeZone } from '../../../../utils'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux'
import { setPatientTimeZone } from '../../../../../store/actions/patient'

const useStyles = makeStyles(() => ({
    container: {
        width: '100%',
        marginBottom: '17px',
    },
    checkboxLabel: {
        '& .MuiFormControlLabel-root': {
            marginRight: '0 !important',
            '& .MuiIconButton-root': {
                paddingBottom: '0 !important',
                paddingTop: '0 !important',
            },
        },
    },
    container2: {
        width: '100%',
        marginTop: '15px',
        borderTop: '1px solid #CFCFCF',
    },
    insurance: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #bfbfbf',
        borderRadius: '5px',
        height: '3.0em',
    }
}))

const formatNumber = (value = '') => {
    let clearNumber = value.replace(/[^0-9]+/g, '')
    const input = clearNumber.replace(/\D/g, '').substring(0, 10) // First ten digits of input only
    const zip = input.substring(0, 3)
    const middle = input.substring(3, 6)
    const last = input.substring(6, 10)

    if (input.length > 6) {
        clearNumber = `(${zip}) ${middle}-${last}`
    } else if (input.length > 3) {
        clearNumber = `(${zip}) ${middle}`
    } else if (input.length > 0) {
        clearNumber = `(${zip}`
    }
    return clearNumber
}

function NewPatientCreateForm(props){
    const classes = useStyles()
    const dispatch = useDispatch()
    const sexOptions = useMemo(() => [
        { key: 1, value: 'Male' },
        { key: 2, value: 'Female' },
        { key: 3, value: 'Unknown' },
    ], []);
    const stateOptions = useMemo(
        () => stateList.map((item) => ({ key: item.state, value: item.stateLabel })),
        []
    );
    const allowedRace = [
        'american indian or alaska native',
        'asian',
        'black or african american',
        'native hawaiian or other pacific islander',
        'white',
        'declined to specify'
      ];

      const allowedEthnicity = [
        'hispanic or latino',
        'not hispanic or latino',
        'declined to specify'
      ];
      const timezoneList = [
        {
          key: "PST",
          value: "Pacific Standard Time",
          iana: "US/Pacific"
        },
        {
          key: "MST",
          value: "Mountain Standard Time",
          iana: "US/Mountain"
        },
        {
          key: "CST",
          value: "Central Standard Time",
          iana: "US/Central"
        },
        {
          key: "EST",
          value: "Eastern Standard Time",
          iana: "US/Eastern"
        },
        {
          key: "AKST",
          value: "Alaska Standard Time",
          iana: "US/Alaska"
        },
        {
          key: "HST",
          value: "Hawaii Standard Time",
          iana: "US/Hawaii"
        }
      ];
      
    const [open, setOpen] = React.useState(false)
    const [currentTab, setCurrentTab] = React.useState(0)
    const tabContentRefs = React.useRef([])
    const wasZipAutoPopulated = React.useRef(false)
    const [scrolledTabs, setScrolledTabs] = React.useState([])

    const [genderList, setGenderList] = React.useState([])
    const [sexualOrientationList, setSexualOrientationList] = React.useState([])
    const [raceList, setRaceList] = React.useState([])
    const [ethinicitylist, Setethinicitylist] = React.useState([])

    const toggleOpen = useCallback(() => {
        setOpen(true);
        setCurrentTab(0);
    }, []);
    const goToPage = useCallback((url) => {
        window.open(url, '_blank');
    }, []);

    const additionalDemoGraphy = async() =>{
        try{
            const res = await getAdditionalDemo()
            if(res?.status === 200){
                setGenderList(
                    Array.isArray(res?.data?.genderindentitylist) && res.data.genderindentitylist.length > 0
                      ? res.data.genderindentitylist.map(item => ({
                          key: item['@uid'], 
                          value: item['@description']
                        }))
                      : []
                    );
                setSexualOrientationList(
                    Array.isArray(res?.data?.sexualorientationlist) && res.data.sexualorientationlist.length > 0
                        ? res.data.sexualorientationlist.map(item => ({
                            key: item['@uid'], 
                            value: item['@description']
                        }))
                        : []
                    );
                setRaceList(
                    Array.isArray(res?.data?.racelist) && res.data.racelist.length > 0
                        ? res.data.racelist
                        .map(item => ({
                          key: item['@id'],
                          value: item['@name']
                        }))
                        .filter(item => allowedRace.includes(item.value.toLowerCase()))
                        : []
                    );
                Setethinicitylist(
                    Array.isArray(res?.data?.ethinicitylist) && res.data.ethinicitylist.length > 0
                        ? res.data.ethinicitylist.map(item => ({
                            key: item['@id'], 
                            value: item['@name']
                        }))
                        .filter(item => allowedEthnicity.includes(item.value.toLowerCase()))
                        : []
                    );
            }
        }catch(error){
            console.log("err",error)
        }
    }
    useEffect(()=>{
        additionalDemoGraphy()
    },[])
    useEffect(()=>{
        props?.setPatientHaveInsurance(true)
        props?.setSelfpay(false)
    },[])
    useEffect(()=>{
        if(props.formik.values.timeZone){
            dispatch(setPatientTimeZone(timezoneList.find(item =>item?.key == props.formik.values.timeZone)?.iana))
        }
    },[props.formik.values.timeZone])
    

    return (
        <div className="booking_boxes">
            <div>
                <Typography className="step-headers">
                    Please fill out the new patient form.
                </Typography>
            </div>
            <div className={`patient-form-outline`}>
                <>
                    <Grid container className={classes.container} spacing={2} xs={12}>
                        <span className="form-header">Patient Information</span>
                        <Grid container alignItems="flex-start" spacing={2}>
                            <Grid item xs={12} lg={6} md={6}>
                                <TextBox
                                    label="First Name"
                                    required
                                    name="first_name"
                                    placeholder=""
                                    value={props.formik.values.first_name}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('first_name', value)
                                            props.formik.setTouched({
                                                ...props.formik.touched,
                                                first_name: true,
                                            })
                                    }}
                                    error={
                                        props.formik.touched.first_name &&
                                        Boolean(props.formik.errors.first_name)
                                    }
                                    helperText={
                                        props.formik.touched.first_name &&
                                        props.formik.errors.first_name
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} lg={6} md={6}>
                                <TextBox
                                    label="Last Name"
                                    required
                                    name="last_name"
                                    placeholder=""
                                    value={props.formik.values.last_name}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('last_name', value)
                                        props.formik.setTouched({
                                            ...props.formik.touched,
                                            last_name: true,
                                        })
                                    }}
                                    error={
                                        props.formik.touched.last_name &&
                                        Boolean(props.formik.errors.last_name)
                                    }
                                    helperText={
                                        props.formik.touched.last_name &&
                                        props.formik.errors.last_name
                                    }
                                />
                            </Grid>
                        </Grid>
                        {/* Middle Name and preferName */}
                        <Grid
                            container
                            alignItems="flex-start"
                            spacing={2}
                            style={{ marginTop: '5px' }}>
                            <Grid item xs={12} lg={6} md={6}>
                                <TextBox
                                    label="Middle Name"
                                    name="middle_name"
                                    placeholder=""
                                    value={props.formik.values.middle_name}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('middle_name', value)
                                    }}
                                    error={
                                        props.formik.touched.middle_name &&
                                        Boolean(props.formik.errors.middle_name)
                                    }
                                    helperText={
                                        props.formik.touched.middle_name &&
                                        props.formik.errors.middle_name
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} lg={6} md={6}>
                                <TextBox
                                    label="preferred Name"
                                    name="preferred_name"
                                    placeholder=""
                                    value={props.formik.values.preferred_name}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('preferred_name', value)
                                    }}
                                    error={
                                        props.formik.touched.preferred_name &&
                                        Boolean(props.formik.errors.preferred_name)
                                    }
                                    helperText={
                                        props.formik.touched.preferred_name &&
                                        props.formik.errors.preferred_name
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="flex-start"
                            spacing={2}
                            style={{ marginTop: '5px' }}>
                            <Grid item xs={12} lg={3} md={6}>
                                {/* <DatePicker
                                    label="Date of Birth"
                                    required
                                    name="dob"
                                    value={props.formik.values.dob}
                                    maxDate={new Date()}
                                    error={
                                        props.formik.touched.dob && Boolean(props.formik.errors.dob)
                                    }
                                    helperText={props.formik.touched.dob && props.formik.errors.dob}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('dob', value)
                                    }}
                                    notDefaultValue
                                /> */}
                                <FormLabel
                                    component="p"
                                    className="d-flex justify-space-between align-center"
                                    style={{ fontSize: 14, fontWeight: 500 }}>
                                    <span
                                        className={`${classes.checkboxLabel} required`}
                                        style={{ color: '#303E4E' }}>
                                        Date of Birth
                                    </span>

                                </FormLabel>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        className="ba-input-fields each_input_holder ba-date-input"
                                        inputVariant="outlined"
                                        variant="inline"
                                        format="MM/DD/YYYY"
                                        name="dob"
                                        maxDate={new Date()}
                                        autoOk={true}
                                        placeholder={''}
                                        value={props.formik.values.dob || null}
                                        onChange={(e) => {
                                            if (e) {
                                                props.formik.setFieldValue(
                                                    'dob',
                                                    moment(e).format('MM/DD/YYYY')
                                                );
                                            }
                                            props.formik.setTouched({
                                                ...props.formik.touched,
                                                dob: true,
                                            })
                                        }}
                                        helperText={props.formik.touched.dob && props.formik.errors.dob}
                                        error={
                                            props.formik.touched.dob && Boolean(props.formik.errors.dob)
                                        }
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12} lg={3} md={6}>
                                <TextBox
                                    label="Cell Phone Number"
                                    required
                                    name="phone_number"
                                    value={formatNumber(props.formik.values.phone_number)}
                                    placeholder=""
                                    error={
                                        props.formik.touched.phone_number &&
                                        Boolean(props.formik.errors.phone_number)
                                    }
                                    helperText={
                                        props.formik.touched.phone_number &&
                                        props.formik.errors.phone_number
                                    }
                                    onChange={(value) => {
                                        props.formik.setFieldValue(
                                            'phone_number',
                                            value.replace(/[^0-9]+/g, '').substring(0, 10),
                                        ),
                                            props.formik.setTouched({
                                                ...props.formik.touched,
                                                phone_number: true,
                                            })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} lg={6} md={6}>
                                <TextBox
                                    label="Email"
                                    required
                                    name="email"
                                    value={props.formik.values.email}
                                    placeholder=""
                                    error={
                                        props.formik.touched.email &&
                                        Boolean(props.formik.errors.email)
                                    }
                                    helperText={
                                        props.formik.touched.email && props.formik.errors.email
                                    }
                                    onChange={(value) => {
                                        props.formik.setTouched({
                                            ...props.formik.touched,
                                            email: true,
                                        }),
                                            props.formik.setFieldValue('email', value)
                                    }}
                                />
                            </Grid>
                            {/* <Grid item xs={12} lg={4} md={4}>
                                <Select
                                    label="Sex Assigned at Birth"
                                    required
                                    name="sex"
                                    placeholder=""
                                    options={sexOptions}
                                    selectProps={{
                                        style: {
                                            height: 40,
                                        },
                                    }}
                                    value={props.formik.values.sex}
                                    error={
                                        props.formik.touched.sex && Boolean(props.formik.errors.sex)
                                    }
                                    helperText={props.formik.touched.sex && props.formik.errors.sex}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('sex', value),
                                            props.formik.setTouched({
                                                ...props.formik.touched,
                                                sex: true,
                                            })
                                    }}
                                />
                            </Grid> */}
                            <Grid item xs={12} lg={3} md={6}>
                                <Select
                                    label="Sex"
                                    required
                                    name="gender"
                                    placeholder=""
                                    options={genderList}
                                    selectProps={{
                                        style: {
                                            height: 40,
                                        },
                                    }}
                                    value={props.formik.values.gender}
                                    error={
                                        props.formik.touched.gender && Boolean(props.formik.errors.gender)
                                    }
                                    helperText={props.formik.touched.gender && props.formik.errors.gender}
                                    onChange={(value) => {
                                        const label = genderList.find((item)=>(item?.key == value))
                                        props?.formik.setFieldValue('sex', label?.value)
                                        props.formik.setFieldValue('gender', value),
                                            props.formik.setTouched({
                                                ...props.formik.touched,
                                                gender: true,
                                            })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} lg={9} md={12}>
                                <FormLabel
                                    component="p"
                                    className="d-flex justify-space-between align-center"
                                    style={{ fontSize: 14, fontWeight: 500 }}>
                                    <span
                                        className={`${classes?.checkboxLabel} required`}
                                        style={{ color: '#303E4E' }}>
                                        <span>
                                            Insurance {' '}
                                        </span>
                                    </span>
                                </FormLabel>
                                <div className={classes?.insurance} style={{gap: !props?.isMobileView && '50px'}}>
                                    <FormControlLabel
                                        value="a"
                                        control={
                                        <Radio
                                            checked={props.patientHaveInsurance}
                                            onChange={(e)=>{
                                                props?.setPatientHaveInsurance(true)
                                                props?.setSelfpay(false)
                                                props?.setErrorMessageforRadio(false)
                                            }}
                                            name="radio-buttons"
                                            color="primary"
                                        />
                                        }
                                        label="I have insurance"
                                    />
                                    <FormControlLabel
                                            value="a"
                                            disabled
                                            control={
                                            <Radio
                                                checked={props?.selfpay}
                                                onChange={(e)=>{
                                                    props?.setPatientHaveInsurance(false)
                                                    props?.setSelfpay(true)
                                                    props?.setErrorMessageforRadio(false)
                                                }}
                                                name="radio-buttons"
                                                color="primary"
                                                disabled
                                            />
                                            }
                                            label="Self Pay"
                                        />
                                </div>
                                {props?.errorMessageForRadio && <FormHelperText style={{color:'red'}}>Please select an option.</FormHelperText>}
                            </Grid>
                            {/* <Grid item xs={12} lg={6} md={6}>
                                <Select
                                    resetData
                                    label="Sexual Orientation"
                                    name="orientation"
                                    placeholder=""
                                    options={sexualOrientationList}
                                    selectProps={{
                                        style: {
                                            height: 40,
                                        },
                                    }}
                                    value={props.formik.values.orientation}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('orientation', value)
                                    }}
                                />
                            </Grid> */}
                        </Grid>
                        {/* get additional Demographics */}
                        {/* <Grid
                            container
                            alignItems="flex-start"
                            spacing={2}
                            style={{ marginTop: '5px' }}>
                                <Grid item xs={12} lg={4} md={4}>
                                    <FormLabel
                                        component="p"
                                        className="d-flex justify-space-between align-center"
                                        style={{ fontSize: 14, fontWeight: 500 }}>
                                        <span
                                            className={`${classes.checkboxLabel}`}
                                            style={{ color: '#303E4E' }}>
                                            Race
                                        </span>
                                    </FormLabel>
                                    <Autocomplete
                                        value={props.formik.values.race || null}
                                        options={raceList.sort((a, b) => a.value.localeCompare(b.value))}
                                        getOptionLabel={(states) => states.value}
                                        onChange={(_, newValue) => {
                                            props.formik.setFieldValue('race', newValue)
                                        }}
                                        popupIcon={<ExpandMoreIcon />}
                                        disableClearable={false}
                                        renderInput={(params) => (
                                            <TextBox
                                                name="Textname"
                                                {...params}
                                                placeholder=""
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} lg={4} md={4}>
                                    <FormLabel
                                        component="p"
                                        className="d-flex justify-space-between align-center"
                                        style={{ fontSize: 14, fontWeight: 500 }}>
                                        <span
                                            className={`${classes.checkboxLabel}`}
                                            style={{ color: '#303E4E' }}>
                                            Ethnicity
                                        </span>
                                    </FormLabel>
                                    <Autocomplete
                                        value={props.formik.values.ethnicity || null}
                                        options={ethinicitylist.sort((a, b) => a.value.localeCompare(b.value))}
                                        getOptionLabel={(states) => states.value}
                                        onChange={(_, newValue) => {
                                            props.formik.setFieldValue('ethnicity', newValue)
                                        }}
                                        popupIcon={<ExpandMoreIcon />}
                                        disableClearable={false}
                                        renderInput={(params) => (
                                            <TextBox
                                                name="Textname"
                                                {...params}
                                                placeholder=""
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} lg={4} md={4}>
                                    <FormLabel
                                        component="p"
                                        className="d-flex justify-space-between align-center"
                                        style={{ fontSize: 14, fontWeight: 500 }}>
                                        <span
                                            className={`${classes.checkboxLabel}`}
                                            style={{ color: '#303E4E' }}>
                                            Primary Language
                                        </span>
                                    </FormLabel>
                                    <Autocomplete
                                        value={props.formik.values.preferredlanguage || null}
                                        options={preferredlanguageList}
                                        getOptionLabel={(states) => states.description}
                                        onChange={(_, newValue) => {
                                            props.formik.setFieldValue('preferredlanguage', newValue)
                                        }}
                                        popupIcon={<ExpandMoreIcon />}
                                        disableClearable={false}
                                        renderInput={(params) => (
                                            <TextBox
                                                name="Textname"
                                                {...params}
                                                placeholder=""
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>
                        </Grid> */}
                    </Grid>
                    
                    {/* Address Field */}
                    <Grid container className={classes.container2} spacing={2} xs={12}>
                        <span className="form-header" style={{ marginTop: '10px' }}>
                            {' '}
                            Address
                        </span>
                        <Grid container alignItems="flex-start" spacing={2}>
                            <Grid item xs={12}>
                                <TextBox
                                    label="Address Line 1"
                                    required
                                    name="address_one"
                                    value={props.formik.values.address_one}
                                    placeholder=""
                                    error={
                                        props.formik.touched.address_one &&
                                        Boolean(props.formik.errors.address_one)
                                    }
                                    helperText={
                                        props.formik.touched.address_one &&
                                        props.formik.errors.address_one
                                    }
                                    onChange={(value) => {
                                        props.formik.setFieldValue('address_one', value),
                                            props.formik.setTouched({
                                                ...props.formik.touched,
                                                address_one: true,
                                            })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextBox
                                    label="Address Line 2"
                                    name="address_two"
                                    value={props.formik.values.address_two}
                                    placeholder=""
                                    error={
                                        props.formik.touched.address_two &&
                                        Boolean(props.formik.errors.address_two)
                                    }
                                    helperText={
                                        props.formik.touched.address_two &&
                                        props.formik.errors.address_two
                                    }
                                    onChange={(value) =>
                                        props.formik.setFieldValue('address_two', value)
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="flex-start"
                            spacing={2}
                            style={{ marginTop: '5px' }}>
                            <Grid item xs={6} lg={3} md={6}>
                                <TextBox
                                    label="City"
                                    required
                                    name="city"
                                    value={props.formik.values.city}
                                    placeholder=""
                                    error={
                                        props.formik.touched.city &&
                                        Boolean(props.formik.errors.city)
                                    }
                                    helperText={
                                        props.formik.touched.address_two && props.formik.errors.city
                                    }
                                    onChange={(value) => {
                                        props.formik.setFieldValue('city', value),
                                            props.formik.setTouched({
                                                ...props.formik.touched,
                                                city: true,
                                            })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} lg={3} md={6}>
                                <Select
                                    label="State"
                                    required
                                    name="state"
                                    placeholder=""
                                    options={stateOptions}
                                    selectProps={{
                                        style: {
                                            height: 40,
                                        },
                                    }}
                                    value={props.formik.values.state}
                                    error={
                                        props.formik.touched.state &&
                                        Boolean(props.formik.errors.state)
                                    }
                                    helperText={
                                        props.formik.touched.state && props.formik.errors.state
                                    }
                                    onChange={(value) => {
                                        props.formik.setFieldValue('state', value)
                                        wasZipAutoPopulated.current = false
                                        // const iana = StateTimeZone[value]?.default;
                                        // const timezone = timezoneList.find((item) => item.iana === iana);
                                        // const key = timezone ? timezone?.key : '';
                                        // props.formik.setFieldValue('timeZone', key)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} lg={3} md={6}>
                                <TextBox
                                    label="Zip Code"
                                    required
                                    name="zip_code"
                                    value={props.formik.values.zip_code}
                                    placeholder=""
                                    error={
                                        props.formik.touched.zip_code &&
                                        Boolean(props.formik.errors.zip_code)
                                    }
                                    helperText={
                                        props.formik.touched.zip_code &&
                                        props.formik.errors.zip_code
                                    }
                                    onChange={(value) => {
                                        const cleanZip = value.replace(/[^0-9]+/g, '').substring(0, 5)
                                        props.formik.setFieldValue('zip_code', cleanZip)
                                        props.formik.setTouched({
                                            ...props.formik.touched,
                                            zip_code: true,
                                        })
                                        if (cleanZip.length === 5) {
                                            const detectedState = getStateFromZip(cleanZip)
                                            if (detectedState) {
                                                props.formik.setFieldValue('state', detectedState)
                                                wasZipAutoPopulated.current = true
                                            } else if (wasZipAutoPopulated.current) {
                                                props.formik.setFieldValue('state', '')
                                                wasZipAutoPopulated.current = false
                                            }
                                        } else if (wasZipAutoPopulated.current) {
                                            props.formik.setFieldValue('state', '')
                                            wasZipAutoPopulated.current = false
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} lg={3} md={6}>
                                <Select
                                    label="Time Zone"
                                    required
                                    name="timeZone"
                                    placeholder=""
                                    options={timezoneList}
                                    selectProps={{
                                        style: {
                                            height: 40,
                                        },
                                    }}
                                    value={props.formik.values.timeZone}
                                    error={
                                        props.formik.touched.timeZone && Boolean(props.formik.errors.timeZone)
                                    }
                                    helperText={props.formik.touched.timeZone && props.formik.errors.timeZone}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('timeZone', value),
                                            props.formik.setTouched({
                                                ...props.formik.touched,
                                                timeZone: true,
                                            })
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            </div>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={props?.loaderOpen}
                // onClick={handleClosePop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div className="terms">
                <CheckboxOption
                    name="releaseOfInfo"
                    option={{ label: '', value: true }}
                    // checked={props.values.releaseOfInfo}
                    // onChange={toggleOpen}
                    checked={props.isCheckboxEnabled}
                    onChange={(e)=>{props.isCheckboxEnabled ? props.setIsCheckboxEnabled(false) : props.setIsCheckboxEnabled(true)}}
                    disabled={false}
                    defaultChecked={false}
                    classRoot=""
                    customStyle={{ marginTop: 2 }}
                />
                <span className="agreement">
                    I agree to the TeleMed2U{' '}
                    <a
                        href="https://www.telemed2u.com/terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Terms & Conditions</a>
                    ,{' '}
                    <a
                        href="https://www.telemed2u.com/informed-consent-for-medical-services"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Informed Consent for Medical Services</a>
                    ,{' '}
                    <a
                        href="https://www.telemed2u.com/telehealth-consent-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Telehealth Consent</a>
                    ,{' '}
                    <a
                        href="https://www.telemed2u.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Privacy Policy</a>
                    {' '}
                    and{' '}
                    <a
                        href="https://www.telemed2u.com/notice-of-privacy-practices"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Notice of Privacy Practices</a>
                    , and understand all of these can be accessed at any time on{' '}
                    <a
                        href="https://www.telemed2u.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >telemed2u.com</a>
                    . I have read and give my permission for the{' '}
                    <a
                        href="https://www.telemed2u.com/release-of-information"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Release of Information</a>
                    .
                </span>
                {/* {open && (
                    <IntakeModalForm
                        open={open}
                        toggleOpen={setOpen}
                        onModalClose={() => setOpen(false)}
                        currentTab={currentTab}
                        setCurrentTab={setCurrentTab}
                        tabContentRefs={tabContentRefs}
                        isCheckboxEnabled={props.isCheckboxEnabled}
                        setIsCheckboxEnabled={props.setIsCheckboxEnabled}
                        scrolledTabs={scrolledTabs}
                        setScrolledTabs={setScrolledTabs}
                        values={props.values}
                        setValues={props.setValues}
                        sign={props.sign}
                        setSign={props.setSign}
                    />
                )} */}
            </div>
        </div>
    )
}
export default React.memo(NewPatientCreateForm)
